import _ from 'lodash';
import * as MksAPI from '../../_config/mksAPI';
import {
  SAVE_CYLINDERS,
  SET_SELECTED_CYLINDER,
  SAVE_KEYS,
  SET_SELECTED_KEY,
  SAVE_RELATIONS,
  RESET_MKS_DATA,
  SAVE_MKS_REQUESTS,
  SET_SELECTED_MKS_REQUEST,
  SAVE_MKS_REQUEST_DETAIL,
  UPDATE_MKS_REQUEST,
  DELETE_MKS_REQUEST,
  EXPORT_MKS_REQUESTS,
  RESET_MKS_REQUESTS_DATA,
  RESET_MKS_CYLINDERS_DATA,
  RESET_MKS_KEYS_DATA,
  RESET_MKS_RELATIONS_DATA,
  SET_MKS_FILTER,
  RESET_MKS_FILTER,
} from './actionTypes/mks';
import * as formatter from '../../_config/formatter';

export function saveCylinders(cylinders) {
  return {
    type: SAVE_CYLINDERS,
    cylinders,
  };
}

export function setSelectedCylinder(cylinder) {
  return {
    type: SET_SELECTED_CYLINDER,
    cylinder,
  };
}

export function saveKeys(keys) {
  return {
    type: SAVE_KEYS,
    keys,
  };
}

export function setSelectedKey(key) {
  return {
    type: SET_SELECTED_KEY,
    key,
  };
}


export function saveRelations(relations) {
  return {
    type: SAVE_RELATIONS,
    relations,
  };
}

export function resetMksDataAction() {
  return {
    type: RESET_MKS_DATA,
  };
}

export function saveMksRequests(requests) {
  return {
    type: SAVE_MKS_REQUESTS,
    requests,
  };
}

export function setSelectedMksRequestAction(request) {
  return {
    type: SET_SELECTED_MKS_REQUEST,
    request,
  };
}

export function saveMksRequestDetail(requestDetail) {
  return {
    type: SAVE_MKS_REQUEST_DETAIL,
    requestDetail,
  };
}

export function updateMksRequestAction(request) {
  return {
    type: UPDATE_MKS_REQUEST,
    request,
  };
}

export function deleteMksRequestAction(request) {
  return {
    type: DELETE_MKS_REQUEST,
    request,
  };
}

export function exportMksRequestsAction(requests) {
  return {
    type: EXPORT_MKS_REQUESTS,
    requests,
  };
}

export function resetMksRequestsDataAction() {
  return {
    type: RESET_MKS_REQUESTS_DATA,
  };
}

export function resetMksCylindersDataAction() {
  return {
    type: RESET_MKS_CYLINDERS_DATA,
  };
}

export function resetMksKeysDataAction() {
  return {
    type: RESET_MKS_KEYS_DATA,
  };
}

export function resetMksRelationsDataAction() {
  return {
    type: RESET_MKS_RELATIONS_DATA,
  };
}

export function setMksFilter(filterKey, filterValue) {
  return {
    type: SET_MKS_FILTER,
    filterKey,
    filterValue,
  };
}

export function resetMksFilter() {
  return {
    type: RESET_MKS_FILTER,
  };
}



export function fetchCylinders(page = 0, pageSize = 200) {
  return async (dispatch, getState) => {
    try {
      const response = await MksAPI.fetchCylinders({ page, pageSize });
      if (response && response.data) {
        dispatch(saveCylinders(response.data));
        return response.data;
      } else {
        dispatch(saveCylinders({ content: [], pagination: { page: 0, pageSize: 0, totalElements: 0, totalPages: 0 } }));
        throw new Error();
      }
    } catch (error) {
      dispatch(saveCylinders({ content: [], pagination: { page: 0, pageSize: 0, totalElements: 0, totalPages: 0 } }));
      throw error;
    }
  };
}

export function fetchKeys(page = 0, pageSize = 200) {
  return async (dispatch, getState) => {
    try {
      const response = await MksAPI.fetchKeys({ page, pageSize });
      if (response && response.data) {
        dispatch(saveKeys(response.data));
        return response.data;
      } else {
        dispatch(saveKeys({ content: [], pagination: { page: 0, pageSize: 0, totalElements: 0, totalPages: 0 } }));
        throw new Error();
      }
    } catch (error) {
      dispatch(saveKeys({ content: [], pagination: { page: 0, pageSize: 0, totalElements: 0, totalPages: 0 } }));
      throw error;
    }
  };
}

export function fetchMksDataForSelectedDomain() {
  return async (dispatch, getState) => {
    try {
      await dispatch(fetchCylinders());
    } catch (error) {}
    try {
      await dispatch(fetchKeys());
    } catch (error) {}
    try {
      await dispatch(fetchMechanicalCylinderKeyRelations());
    } catch (error) {}
  };
}

export function selectCylinder(cylinder) {
  return (dispatch) => {
    dispatch(setSelectedCylinder(cylinder));
  };
}

export function selectKey(key) {
  return (dispatch) => {
    dispatch(setSelectedKey(key));
  };
}


export function resetMksData() {
  return (dispatch) => {
    dispatch(resetMksDataAction());
  };
}

export function fetchMechanicalCylinderKeyRelations(page = 0, pageSize = 10000) {
  return async (dispatch, getState) => {
    try {
      const response = await MksAPI.fetchMechanicalCylinderKeyRelations({ page, pageSize });
      if (response && response.data) {
        dispatch(saveRelations(response.data));
        return response.data;
      } else {
        dispatch(saveRelations({ content: [], pagination: { page: 0, pageSize: 0, totalElements: 0, totalPages: 0 } }));
        throw new Error();
      }
    } catch (error) {
      dispatch(saveRelations({ content: [], pagination: { page: 0, pageSize: 0, totalElements: 0, totalPages: 0 } }));
      throw error;
    }
  };
}

export function fetchCylinderRelations(cylinderId, page = 0, pageSize = 10000) {
  return async (dispatch, getState) => {
    try {
      const { hostname } = getState().user.token;
      const response = await MksAPI.fetchMechanicalCylinderKeyRelations({ hostname, cylinderId, page, pageSize });
      if (response && response.data) {
        return response.data;
      } else {
        throw new Error();
      }
    } catch (error) {
      throw error;
    }
  };
}

export function fetchKeyRelations(keyId, page = 0, pageSize = 10000) {
  return async (dispatch, getState) => {
    try {
      const { hostname } = getState().user.token;
      const response = await MksAPI.fetchMechanicalCylinderKeyRelations({ hostname, keyId, page, pageSize });
      if (response && response.data) {
        return response.data;
      } else {
        throw new Error();
      }
    } catch (error) { 
      throw error;
    }
  };
}

export function fetchMKSRequests(page = 0, pageSize = 100) {
  return async (dispatch, getState) => {
    try {
      const { hostname } = getState().user.token;
      const filters = getState().mks.mksRequests.filters || {};
      const response = await MksAPI.fetchMKSRequests({ 
        hostname, 
        page, 
        pageSize,
        ...filters,
      });
      if (response && response.data) {
        dispatch(saveMksRequests(response.data));
        return response.data;
      } else {
        throw new Error();
      }
    } catch (error) {
      throw error;
    }
  };
}

export function fetchMKSRequestById(requestId) {
  return async (dispatch, getState) => {
    try {
      const response = await MksAPI.fetchMKSRequestById(requestId);
      if (response && response.data) {
        dispatch(saveMksRequestDetail(response.data));
        return response.data;
      } else {
        throw new Error();
      }
    } catch (error) {
      throw error;
    }
  };
}

export function createMKSRequest(data) {
  return async (dispatch, getState) => {
    try {
      const formattedData = formatter.formatOutputData(formatter.MKS_REQUEST, data);
      const response = await MksAPI.createMKSRequest(formattedData);
      if (response && response.data) {
        dispatch(saveMksRequestDetail(response.data));
        return response.data;
      } else {
        throw new Error();
      }
    } catch (error) {
      throw error;
    }
  };
}

export function updateMKSRequest(requestId, data) {
  return async (dispatch, getState) => {
    try {
      const response = await MksAPI.updateMKSRequest(requestId, data);
      if (response && response.data) {
        dispatch(updateMksRequestAction(response.data));
        return response.data;
      } else {
        throw new Error();
      }
    } catch (error) {
      throw error;
    }
  };
}


export function deleteMKSRequest(requestId) {
  return async (dispatch, getState) => {
    try {
      const response = await MksAPI.deleteMKSRequest(requestId);
      if (response && response.data) {
        dispatch(deleteMksRequestAction(response.data));
        return response.data;
      } else {
        throw new Error();
      }
    } catch (error) {
      throw error;
    }
  };
}

export function exportMKSRequests(params) {
  return async (dispatch, getState) => {
    try {
      const response = await MksAPI.exportMKSRequests(params);
      if (response && response.data) {
        dispatch(exportMksRequestsAction(response.data));
        return response.data;
      } else {
        throw new Error();
      }
    } catch (error) {
      throw error;
    }
  };
}

export function setSelectedMksRequest(request) {
  return (dispatch) => {
    dispatch(setSelectedMksRequestAction(request));
  };
}

export function resetMksRequestsData() {
  return (dispatch) => {
    dispatch(resetMksRequestsDataAction());
  };
}

export function resetMksCylindersData() {
  return (dispatch) => {
    dispatch(resetMksCylindersDataAction());
  };
}

export function resetMksKeysData() {
  return (dispatch) => {
    dispatch(resetMksKeysDataAction());
  };
}

export function resetMksRelationsData() {
  return (dispatch) => {
    dispatch(resetMksRelationsDataAction());
  };
}

export function fetchCylinderById(cylinderId) {
  return async (dispatch, getState) => {
    try {
      const response = await MksAPI.fetchCylinderById(cylinderId);
      if (response && response.data) {
        return response.data;
      } else {
        throw new Error();
      }
    } catch (error) {
      throw error;
    }
  };
}

export function fetchKeyById(keyId) {
  return async (dispatch, getState) => {
    try {
      const response = await MksAPI.fetchKeyById(keyId);
      if (response && response.data) {
        return response.data;
      } else {
        throw new Error();
      }
    } catch (error) {
      throw error;
    }
  };
}